(() => {
  const selector = '[data-verso-notes-reveal]';
  const initializedSections = new WeakSet();
  const clamp = (value) => Math.min(1, Math.max(0, value));

  const initialize = (section) => {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animationFrame = null;

    const render = () => {
      animationFrame = null;

      if (reducedMotion.matches) {
        section.classList.remove('is-enhanced');
        return;
      }

      section.classList.add('is-enhanced');

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const sectionTop = section.getBoundingClientRect().top;
      const introProgress = clamp((viewportHeight * 0.9 - sectionTop) / (viewportHeight * 0.75));
      const detailProgress = clamp((-sectionTop - viewportHeight * 0.08) / (viewportHeight * 0.45));

      section.style.setProperty('--verso-notes-intro-opacity', introProgress.toFixed(3));
      section.style.setProperty('--verso-notes-product-shift', `${((1 - introProgress) * 72).toFixed(2)}px`);
      section.style.setProperty('--verso-notes-detail-opacity', detailProgress.toFixed(3));
      section.style.setProperty('--verso-notes-detail-scale', (0.99 + detailProgress * 0.01).toFixed(4));
    };

    const requestRender = () => {
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(render);
    };

    reducedMotion.addEventListener?.('change', requestRender);
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender, { passive: true });
    requestRender();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(selector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
